// import React from "react";
// import PropTypes from "prop-types";
// import Lottie from "lottie-react"; // For loader

// // Removed all MUI Table imports

// const GenericTable = ({
//   columns,
//   rows,
//   tableHeight, // Can be used for a scrollable container for the table
//   loading,
//   loaderAnimation,
//   onRowClick,
//   rowKeyField = "id",
// }) => {
//   if (loading && rows.length === 0) {
//     return (
//       <div
//         className="flex justify-center items-center py-10"
//         style={{ minHeight: tableHeight || 200 }}
//       >
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ height: 80 }}
//         />
//       </div>
//     );
//   }

//   if (!loading && rows.length === 0) {
//     return (
//       // Consistent "No data" styling
//       <div className="text-center text-sm text-gray-500 py-10 border border-gray-200 rounded-md bg-white">
//         No data available.
//       </div>
//     );
//   }

//   // Determine if the table should have its own scroll or grow with content
//   const tableContainerClasses =
//     tableHeight && tableHeight !== "auto" && tableHeight !== "none"
//       ? `overflow-y-auto`
//       : "";
//   const tableContainerStyle =
//     tableHeight && tableHeight !== "auto" && tableHeight !== "none"
//       ? { maxHeight: tableHeight }
//       : {};

//   return (
//     // This outer div provides the border and rounded corners for the table, similar to CustomComponent
//     <div
//       className={`w-full overflow-hidden border border-gray-200 rounded-md ${tableContainerClasses}`}
//       style={tableContainerStyle}
//     >
//       <table className="min-w-full divide-y divide-gray-200 bg-white">
//         {/* Table Head - Styled like CustomComponent's thead */}
//         <thead className="bg-gray-100 sticky top-0 z-10">
//           {/* Added sticky top for header */}
//           <tr>
//             {columns.map((column) => (
//               <th
//                 key={column.id}
//                 scope="col"
//                 style={{ minWidth: column.minWidth }} // Keep minWidth if needed for layout
//                 // Tailwind classes matching CustomComponent's th styling
//                 className={`px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider
//                            ${column.align === "right" ? "text-right" : column.align === "center" ? "text-center" : "text-left"}`}
//               >
//                 {column.label}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         {/* Table Body - Styled like CustomComponent's tbody */}
//         <tbody className="bg-white divide-y divide-gray-200">
//           {rows.map((row, rowIndex) => (
//             <tr
//               key={row[rowKeyField] || rowIndex}
//               onClick={() => onRowClick && onRowClick(row)}
//               // Consistent hover and cursor styling
//               className={`text-xs ${onRowClick ? "hover:bg-gray-50 cursor-pointer" : "hover:bg-gray-50"}`}
//             >
//               {columns.map((column) => {
//                 const value = row[column.id];
//                 return (
//                   <td
//                     key={column.id}
//                     // Tailwind classes matching CustomComponent's td styling
//                     className={`px-4 py-2.5 whitespace-nowrap text-gray-700
//                                ${column.align === "right" ? "text-right" : column.align === "center" ? "text-center" : "text-left"}`}
//                   >
//                     {/* Handling for custom format function (e.g., for action buttons or complex rendering) */}
//                     {column.format && typeof column.format === "function"
//                       ? column.format(value, row) // Pass value and entire row to format function
//                       : value}
//                   </td>
//                 );
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// GenericTable.propTypes = {
//   columns: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//       minWidth: PropTypes.number,
//       align: PropTypes.oneOf(["left", "right", "center"]), // Added center
//       format: PropTypes.func, // Can be a custom render function (value, row) => JSX
//     })
//   ).isRequired,
//   rows: PropTypes.arrayOf(PropTypes.object).isRequired,
//   tableHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   loading: PropTypes.bool,
//   loaderAnimation: PropTypes.object,
//   onRowClick: PropTypes.func,
//   rowKeyField: PropTypes.string,
// };

// export default GenericTable;

import React from "react";
import PropTypes from "prop-types";
import Lottie from "lottie-react";
// 👇 1. IMPORT SORTING ICONS
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

const GenericTable = ({
  columns,
  rows,
  tableHeight,
  loading,
  loaderAnimation,
  onRowClick,
  rowKeyField = "id",
  // 👇 2. NEW PROPS FOR SORTING
  sortConfig, // Object -> { key: 'columnId', direction: 'ascending' | 'descending' }
  requestSort, // Function -> Called when a sortable header is clicked
}) => {
  // Loading and no-data rendering logic (no changes)
  if (loading && rows.length === 0) {
    return (
      <div
        className="flex justify-center items-center py-10"
        style={{ minHeight: tableHeight || 200 }}
      >
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          style={{ height: 80 }}
        />
      </div>
    );
  }
  if (!loading && rows.length === 0) {
    return (
      <div className="text-center text-sm text-gray-500 py-10 ...">
        No data available.
      </div>
    );
  }

  // 👇 3. HELPER FUNCTION TO RENDER THE CORRECT SORT ICON
  const getSortIcon = (columnId) => {
    // If this column is not being sorted, show the default icon
    if (!sortConfig || sortConfig.key !== columnId) {
      return <FaSort className="inline-block ml-1 text-gray-300" />;
    }
    // Otherwise, show the correct direction icon
    if (sortConfig.direction === "ascending") {
      return <FaSortUp className="inline-block ml-1 text-blue-600" />;
    }
    return <FaSortDown className="inline-block ml-1 text-blue-600" />;
  };

  return (
    <div className="w-full overflow-hidden border border-gray-200 rounded-md">
      <table className="min-w-full divide-y divide-gray-200 bg-white">
        <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            {columns.map((column) => (
              <th
                key={column.id}
                scope="col"
                style={{ minWidth: column.minWidth }}
                // 👇 4. MAKE HEADERS CLICKABLE IF THEY ARE SORTABLE
                className={`px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider ${
                  column.sortable
                    ? "cursor-pointer hover:bg-gray-200 transition-colors"
                    : ""
                }`}
                // Call the requestSort function passed from the parent
                onClick={() =>
                  column.sortable && requestSort && requestSort(column.id)
                }
              >
                {column.label}
                {/* Render the sort icon if the column is marked as sortable */}
                {column.sortable && getSortIcon(column.id)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {rows.map((row, rowIndex) => (
            <tr
              key={row[rowKeyField] || rowIndex}
              onClick={() => onRowClick && onRowClick(row)}
              className={`text-xs ${onRowClick ? "hover:bg-gray-50 cursor-pointer" : ""}`}
            >
              {columns.map((column) => (
                <td
                  key={column.id}
                  className="px-4 py-2.5 whitespace-nowrap text-gray-700"
                >
                  {column.format
                    ? column.format(row[column.id], row)
                    : row[column.id]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// 👇 5. UPDATE PROPTYPES
GenericTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      minWidth: PropTypes.number,
      align: PropTypes.oneOf(["left", "right", "center"]),
      format: PropTypes.func,
      sortable: PropTypes.bool, // Add `sortable` to the column definition
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool,
  loaderAnimation: PropTypes.object,
  onRowClick: PropTypes.func,
  rowKeyField: PropTypes.string,
  // New propTypes for sorting
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(["ascending", "descending"]),
  }),
  requestSort: PropTypes.func,
};

export default GenericTable;
